























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Coin from "@/models/porposal/coin.Model";
@Component
export default class CurrencyAdd extends GenericAdd<Coin> {
  constructor() {
    super();
    this.controller = "Coins";
    this.model = new Coin();
 
  }

}
